import { Component } from '@angular/core';

@Component({
    selector: 'backend-branding',
    templateUrl: './branding.component.html',
    styleUrls: ['./branding.component.css'],
    standalone: false
})
export class BrandingComponent {

}
